import { useEffect } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { SendIcon } from 'foundations-assets/icons/components/SendIcon';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H2 } from 'foundations-components/transitional/components/H2';
import I18n from 'I18n';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { readUnhandledEnumCase } from 'rpc-client-utils';
import { trackPageView, trackInteraction } from '../../utils/usageTracker';
import { useCancelSubscriptionMutation } from '../../../__generated__/chirp/com/hubspot/commerce/buyer/portal/rpc/PublicBillingActionsRpc.hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function getBodyMessage(isRequestToCancel, supportEmail, companyName) {
  if (!isRequestToCancel) {
    return 'subscriptions.cancelModal.cancelDescription';
  }
  if (!supportEmail) {
    return 'subscriptions.cancelModal.requestDescriptionNoEmail';
  }
  if (companyName) {
    return 'subscriptions.cancelModal.requestDescriptionWithCompany';
  }
  return 'subscriptions.cancelModal.requestDescription';
}
export function CancelSubscriptionModal({
  onClose,
  isRequestToCancel,
  supportEmail,
  companyName,
  objectId,
  isPreview,
  refetch,
  cancellationAction,
  onRequestSubmitted
}) {
  useEffect(() => {
    trackPageView('cancel-subscription-modal');
  }, []);
  const mode = readUnhandledEnumCase(cancellationAction !== null && cancellationAction !== void 0 ? cancellationAction : '');
  const [cancelSubscription, {
    loading: isCanceling
  }] = useCancelSubscriptionMutation({
    onCompleted: () => {
      trackInteraction('cancel-subscription-succeeded', {
        mode
      });
      if (isRequestToCancel) {
        onRequestSubmitted();
      }
      onClose();
      FloatingAlertStore.addAlert({
        message: I18n.text(isRequestToCancel ? 'subscriptions.cancelModal.requestSuccess' : 'subscriptions.cancelModal.cancelSuccess'),
        type: 'success'
      });
      refetch();
    },
    onError: () => {
      trackInteraction('cancel-subscription-failed', {
        mode
      });
      FloatingAlertStore.addAlert({
        titleText: I18n.text('subscriptions.cancelModal.errorTitle'),
        message: I18n.text('subscriptions.cancelModal.error'),
        type: 'danger'
      });
    }
  });
  const handleConfirm = () => {
    trackInteraction('cancel-subscription-confirmed', {
      mode
    });
    if (isPreview) {
      onClose();
      return;
    }
    void cancelSubscription({
      variables: {
        crmSubscriptionId: objectId
      }
    });
  };
  return /*#__PURE__*/_jsxs(Modal, {
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: isRequestToCancel ? 'subscriptions.cancelModal.requestTitle' : 'subscriptions.cancelModal.cancelTitle'
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose,
        disabled: isCanceling
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(Text, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getBodyMessage(isRequestToCancel, supportEmail, companyName),
          options: {
            supportEmail,
            companyName
          }
        })
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(LoadingButton, {
        use: isRequestToCancel ? 'primary' : 'danger',
        onClick: handleConfirm,
        loading: isCanceling,
        children: isRequestToCancel ? /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "100",
          children: [/*#__PURE__*/_jsx(SendIcon, {
            size: "100"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "subscriptions.cancelModal.sendRequest"
          })]
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.cancelModal.cancelButton"
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "secondary-ghost",
        onClick: onClose,
        disabled: isCanceling,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.close"
        })
      })]
    })]
  });
}